/**Dependencies */
import React from "react";

/**Components */
import { Carousel3D } from "../components/Carousel3D";
import { BannerParallax } from "../components/BannerParallax";
import { BannerDudas } from "../components/BannerDudas";
import { Row, Col } from "react-bootstrap";

/**Images */
import paris from "../images2/paris.png";
import italia from "../images2/italia.png";
import roma from "../images2/roma.png";
import parallaxCircuitos from "../images2/parallax-circuitos.png";
import BannerNecesitasAyuda from "../images2/Necesitas-ayuda.png";
import BannerNecesitasAyudaMovil from "../images2/Necesitas-ayuda-Movil.png";

export const Circuitos = () => {
  const destiniesImages = [
    {
      img: paris,
    },
    {
      img: italia,
    },
    {
      img: roma,
    },
  ];
  return (
    <div>
      <div className="container">
          <Row className="justify-content-lg-end justify-content-center m-0">
              <Col lg={4} sm={12} className="d-lg-grid align-items-center">
                <div className="centered-mobile">
                  <div className="w-100 d-grid justify-content-center">
                    <h1
                      className="text-lg-start text-center destinos-inigualables border-2 border-black border-top pt-4"
                      style={{ fontWeight: "700", letterSpacing: "3px" }}
                    >
                      Circuitos que  inspiran a viajar
                    </h1>
                  </div>
                </div>
              </Col>
              <Col lg={8} sm={12}>            
                <Carousel3D imgsArr={destiniesImages} />
              </Col>
          </Row>
        </div>
      

      <div className="container">
        <h1 className="text-center py-0 py-sm-0 py-lg-5">
          Aquí comienza tu viaje
        </h1>
        <iframe title="megatravel" src="https://www.megatravel.com.mx/tools/ofertas-viaje.php?Dest=&amp;txtColor=6E6E6E&amp;lblTPaq=A812BA&amp;lblTRange=A812BA&amp;lblNumRange=3300FF&amp;itemBack=009e99&amp;ItemHov=A4FF06&amp;txtColorHov=6E6E6E&amp;ff=1" width="100%" height="700"></iframe>
      </div> 
      <div className="py-5">
        <BannerParallax img={parallaxCircuitos} title={"Siente la libertad de viajar"} subtitle={"Descubre las maravillas de cada continente en la mejor época del año"}/>
      </div>
      <div className="py-5">
        <BannerDudas imgDudasDesk={BannerNecesitasAyuda} imgDudasMovil={BannerNecesitasAyudaMovil} bannerDudas={false} />
      </div>

    </div>
  );
};
